export default __webpack_public_path__ + "static/media/MPQ200.77e1aa27.png";